module.exports = __webpack_public_path__ + "img/cross_3.f49c5af1.png";